import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations object
const translations = {
  en: {
    // Navigation & General
    language: "Language",
    home: "Home",
    search: "Search",
    admin: "Admin",
    
    // HomePage
    tagline: "Downloader codes in a flash!",
    searchPlaceholder: "Search for apps...",
    searchButton: "Search",
    faq: "FAQ",
    topSearches: "Top Searches This Month",
    createDownloader: "Create your own Downloader code",
    
    // SearchResults  
    searchResults: "Search Results",
    searchResultsFor: "Search results for",
    noResults: "No results found",
    tryDifferentKeywords: "Try different keywords or browse our categories",
    backToHome: "Back to Home",
    copyCode: "Copy code",
    copied: "Copied!",
    appName: "App Name",
    downloaderCode: "Downloader Code",
    category: "Category", 
    rating: "Rating",
    lastCheck: "Last Check",
    getDownloaderApp: "Get Downloader App",
    rateThisCode: "Rate this code:",
    
    // Voting
    likeTooltip: "Like this code (Good Review)",
    dislikeTooltip: "Dislike this code (Bad Review)",
    alreadyVoted: "You already voted",
    voteFailed: "Failed to submit vote. Please try again.",
    
    // Footer
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    
    // Admin
    loginTitle: "Admin Login", 
    username: "Username",
    password: "Password",
    login: "Login",
    dashboard: "Admin Dashboard",
    logout: "Logout",
    
    // Cookie Consent
    cookieMessage: "We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.",
    acceptCookies: "Accept",
    declineCookies: "Decline",
    
    // FAQ
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Find answers to common questions about downloader codes",
    
    // Search History
    searchHistory: "History",
    recentSearches: "Recent Searches",
    clearHistory: "Clear History", 
    clear: "Clear",
    removeFromHistory: "Remove from history",
    searchHistoryNote: "Search history is stored locally on your device",
    noSearchHistory: "No recent searches",
    searchToCreateHistory: "Start searching to create history",
    recent: "Recent",
    
    // Request Code Feature
    requestNewCode: "Request New Code",
    cantFindCode: "Can't Find Your Code?",
    requestCodeDescription: "Request a new application code and we'll add it to our database",
    requestCodeTitle: "Request New Code",
    requestCodeSubtitle: "Submit a request for a new application code",
    applicationName: "Application Name",
    applicationNameRequired: "Application name is required",
    applicationNamePlaceholder: "Enter application name (e.g., Netflix, Spotify)",
    googlePlayLink: "Google Play Link",
    googlePlayLinkOptional: "Google Play Link (Optional)",
    googlePlayLinkPlaceholder: "https://play.google.com/store/apps/details?id=...",
    additionalDetails: "Additional Details",
    additionalDetailsOptional: "Additional Details (Optional)",
    additionalDetailsPlaceholder: "Any additional information about the app or code...",
    verifyHuman: "Verify you're human",
    verifyHumanRequired: "Verify you're human",
    captchaAnswer: "Answer",
    newQuestion: "New Question",
    submitRequest: "Submit Request",
    submitting: "Submitting...",
    cancel: "Cancel",
    requestsRemaining: "You have {count} request{s} remaining today",
    dailyLimitReached: "Daily limit reached (5 requests per day)",
    requestSubmitted: "Your request has been submitted successfully",
    requestFailed: "Failed to submit request",
    pleaseCompleteCaptcha: "Please complete the captcha",
    incorrectCaptcha: "Incorrect captcha answer. Please try again.",
  },
  
  fr: {
    // Navigation & General  
    language: "Langue",
    home: "Accueil",
    search: "Rechercher", 
    admin: "Admin",
    
    // HomePage
    tagline: "Codes Downloader en un éclair !",
    searchPlaceholder: "Rechercher des applications...",
    searchButton: "Rechercher",
    faq: "FAQ",
    topSearches: "Recherches Populaires Ce Mois",
    createDownloader: "Créez votre propre code Downloader",
    
    // SearchResults
    searchResults: "Résultats de Recherche", 
    searchResultsFor: "Résultats de recherche pour",
    noResults: "Aucun résultat trouvé",
    tryDifferentKeywords: "Essayez d'autres mots-clés ou parcourez nos catégories",
    backToHome: "Retour à l'Accueil",
    copyCode: "Copier le code",
    copied: "Copié !",
    appName: "Nom de l'App",
    downloaderCode: "Code Downloader",
    category: "Catégorie",
    rating: "Note", 
    lastCheck: "Dernière Vérification",
    getDownloaderApp: "Obtenir l'App Downloader",
    rateThisCode: "Noter ce code :",
    
    // Voting
    likeTooltip: "J'aime ce code (Bonne Évaluation)",
    dislikeTooltip: "Je n'aime pas ce code (Mauvaise Évaluation)", 
    alreadyVoted: "Vous avez déjà voté",
    voteFailed: "Échec de l'envoi du vote. Veuillez réessayer.",
    
    // Footer
    termsOfService: "Conditions d'Utilisation",
    privacyPolicy: "Politique de Confidentialité",
    
    // Admin
    loginTitle: "Connexion Admin",
    username: "Nom d'utilisateur", 
    password: "Mot de passe",
    login: "Se connecter",
    dashboard: "Tableau de Bord Admin",
    logout: "Se déconnecter",
    
    // Cookie Consent
    cookieMessage: "Nous utilisons des cookies pour améliorer votre expérience. En continuant à visiter ce site, vous acceptez notre utilisation des cookies.",
    acceptCookies: "Accepter", 
    declineCookies: "Refuser",
    
    // FAQ
    faqTitle: "Questions Fréquemment Posées",
    faqSubtitle: "Trouvez des réponses aux questions courantes sur les codes downloader",
    
    // Search History
    searchHistory: "Historique",
    recentSearches: "Recherches Récentes",
    clearHistory: "Effacer l'Historique",
    clear: "Effacer", 
    removeFromHistory: "Supprimer de l'historique",
    searchHistoryNote: "L'historique de recherche est stocké localement sur votre appareil",
    noSearchHistory: "Aucune recherche récente",
    searchToCreateHistory: "Commencez à rechercher pour créer un historique",
    recent: "Récent",
    
    // Request Code Feature
    requestNewCode: "Demander un Nouveau Code",
    cantFindCode: "Vous ne trouvez pas votre code ?",
    requestCodeDescription: "Demandez un nouveau code d'application et nous l'ajouterons à notre base de données",
    requestCodeTitle: "Demander un Nouveau Code",
    requestCodeSubtitle: "Soumettre une demande pour un nouveau code d'application",
    applicationName: "Nom de l'Application",
    applicationNameRequired: "Le nom de l'application est requis",
    applicationNamePlaceholder: "Entrez le nom de l'application (ex: Netflix, Spotify)",
    googlePlayLink: "Lien Google Play",
    googlePlayLinkOptional: "Lien Google Play (Facultatif)",
    googlePlayLinkPlaceholder: "https://play.google.com/store/apps/details?id=...",
    additionalDetails: "Détails Supplémentaires",
    additionalDetailsOptional: "Détails Supplémentaires (Facultatif)",
    additionalDetailsPlaceholder: "Toute information supplémentaire sur l'application ou le code...",
    verifyHuman: "Vérifier que vous êtes humain",
    verifyHumanRequired: "Vérifier que vous êtes humain",
    captchaAnswer: "Réponse",
    newQuestion: "Nouvelle Question",
    submitRequest: "Soumettre la Demande",
    submitting: "Envoi en cours...",
    cancel: "Annuler",
    requestsRemaining: "Il vous reste {count} demande{s} aujourd'hui",
    dailyLimitReached: "Limite quotidienne atteinte (5 demandes par jour)",
    requestSubmitted: "Votre demande a été soumise avec succès",
    requestFailed: "Échec de la soumission de la demande",
    pleaseCompleteCaptcha: "Veuillez compléter le captcha",
    incorrectCaptcha: "Réponse captcha incorrecte. Veuillez réessayer.",
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  // Load language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred_language');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'fr')) {
      setLanguage(savedLanguage);
    }
  }, []);

  // Save language to localStorage when changed
  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('preferred_language', newLanguage);
  };

  // Get translation function
  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const value = {
    language,
    changeLanguage,
    t,
    isEnglish: language === 'en',
    isFrench: language === 'fr'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};